import DataProcessingService from "./DataProcessingService";
import serviceRegistry from "./services/ServiceRegistry";
import { registerEventHandler } from "../event-registry";

// Services importieren - sie registrieren sich selbst beim Import
import "./services/thalia-chat";
import "./services/contentsquare";
import "./services/braze";
import "./services/quick-lizard";
import "./services/kameleoon";
import "./services/authorizedBy";

const servicesLoaded = [];

/**
 * Holt einen verschachtelten Property-Wert aus einem Objekt.
 * Unterstützt sowohl flache Namen ("Braze") als auch verschachtelte ("authorized.by").
 *
 * @param {Object} obj - Das Objekt
 * @param {string} path - Der Property-Pfad (z.B. "Braze" oder "authorized.by")
 * @returns {*} Der Wert oder undefined
 */
export function getNestedProperty(obj, path) {
	return path.split('.').reduce((current, key) => current?.[key], obj);
}

// Services ohne Consent beim page_view Event laden (statt beim Modulstart)
// Grund: Beim Modulstart ist der DataLayer noch leer, DataProcessingService
// würde auf undefined-Werte prüfen und Services fälschlicherweise ablehnen
let servicesWithoutConsentLoaded = false;
registerEventHandler('page_view', () => {
	if (!servicesWithoutConsentLoaded) {
		initServicesWithoutConsent();
		servicesWithoutConsentLoaded = true;
	}
}, 'consent-init-without-consent');

export default async function consentServiceHandler(model) {
	// Übergangslösung TPE
	const ereaderCookie = await cookieStore.get("ers_trackingConsent");
	const ereaderTrackingCookie = ereaderCookie?.value;
	if (ereaderTrackingCookie && ereaderTrackingCookie.indexOf("true") === 0) {
		return defaultConsenthandler(model);
	}
	// Übergangslösung TPA
	const heimdallCookieObj = await cookieStore.get("COOKIECONSENT");
	const heimdallCookie = heimdallCookieObj?.value;
	if (window.heimdallActive && heimdallCookie === "1") {
		return defaultConsenthandler(model);
	}
	// Usercentrics
	usercentricsEventhandler(model);
}

/**
 * Initialisiert alle Services, die keinen Consent benötigen.
 * Diese Funktion wird beim page_view Event ausgeführt.
 *
 * Services werden automatisch aus der ServiceRegistry geladen.
 */
function initServicesWithoutConsent() {
	const services = serviceRegistry.getServicesWithoutConsent();
	for (const serviceConfig of services) {
		loadServiceByConfig(serviceConfig);
	}
}

/**
 * Generische Funktion zum Laden eines Services basierend auf seiner Konfiguration.
 * Verwendet die ServiceRegistry um die passende Init-Funktion zu finden.
 *
 * @param {Object} serviceConfig - Service-Konfiguration (data-integ.js/data-prod.js)
 * @param {Object} model - Optional: Usercentrics-Model (wird aktuell nicht mehr benötigt)
 * @returns {Promise<boolean>} true wenn Service erfolgreich geladen, false sonst
 */
export async function loadServiceByConfig(serviceConfig, model = null) {
	try {
		const dps = new DataProcessingService(serviceConfig);
		const { name, validEnvironment } = dps;
		const validSampling = await dps.getValidSampling();

		if (!validEnvironment || !validSampling) {
			return false;
		}

		if (servicesLoaded.includes(name)) {
			return false;
		}

		const initFunction = serviceRegistry.getInitFunction(name);
		if (!initFunction) {
			console.warn(`consentApi: No init function found for service: ${name}`);
			return false;
		}


		// Alle Services bekommen nur dps als Parameter
		// Services holen sich DataLayer-Daten über dps.datalayerModel.get()
		initFunction(dps);

		servicesLoaded.push(name);
		return true;
	} catch (fehler) {
		console.error('loadServiceByConfig', fehler)
	}
}

export function usercentricsEventhandler(model) {
	const services = serviceRegistry.getServicesWithConsent();
	for (const data of services) {
		const { name } = data;
		const notLoadedYet = !servicesLoaded.includes(name);
		const serviceOptedIn = getNestedProperty(model, name) === true;
		if (serviceOptedIn && notLoadedYet) {
			loadServiceByConfig(data, model);
		}
	}
}

function defaultConsenthandler(model) {
	const services = serviceRegistry.getServicesWithConsent();
	for (const data of services) {
		loadServiceByConfig(data, model);
	}
}
